import React from "react";
import { educationData } from "../../data/Education";
import TitleButton from "../Title Button/TitleButton";

function Education() {
  const reversedData = [...educationData].reverse();

  return (
    <section
      id='education'
      className='w-full border-b border-line bg-background py-20 md:py-28'
    >
      <div className='swiss-container'>
        <TitleButton title={"Education"} number={"02"} />

        {/* Headline */}
        <div className='mt-10 grid grid-cols-1 gap-6 lg:grid-cols-12 lg:items-end'>
          <h2 className='font-heading text-3xl font-extrabold uppercase leading-[0.95] tracking-tighter text-primary sm:text-4xl md:text-5xl lg:col-span-8'>
            Academic
            <br />
            <span className='text-primary/55'>background</span>
          </h2>
          <p className='font-body text-sm leading-relaxed text-primary/55 md:text-base lg:col-span-4'>
            A continuous journey combining practical IT implementation with
            Computer Science principles.
          </p>
        </div>

        {/* Table-like list */}
        <div className='mt-16 border-t border-primary/60'>
          {/* Column headers */}
          <div className='hidden grid-cols-12 gap-x-10 border-b border-line py-4 lg:grid'>
            <span className='col-span-2 font-body text-2xs font-medium uppercase tracking-widest text-primary/40'>
              Year
            </span>
            <span className='col-span-7 font-body text-2xs font-medium uppercase tracking-widest text-primary/40'>
              Programme
            </span>
            <span className='col-span-3 font-body text-2xs font-medium uppercase tracking-widest text-primary/40'>
              Status
            </span>
          </div>

          {reversedData.map((data, index) => {
            const isCompleted = data.status === "completed";
            const yearText = data.year
              .replace("Graduation: ", "")

            return (
              <div
                key={index}
                className='grid grid-cols-1 gap-x-10 gap-y-4 border-b border-line py-10 lg:grid-cols-12 lg:items-baseline'
              >
                {/* Year */}
                <div className='lg:col-span-2'>
                  <span className='font-heading text-2xl font-bold tabular-nums text-primary md:text-3xl'>
                    {yearText}
                  </span>
                </div>

                {/* Programme */}
                <div className='lg:col-span-7'>
                  <h3 className='font-heading text-xl font-bold leading-snug tracking-tight text-primary md:text-2xl'>
                    {data.title}
                  </h3>
                  <p className='mt-2 font-body text-sm text-primary/55'>
                    {data.name}
                  </p>
                </div>

                {/* Status */}
                <div className='lg:col-span-3'>
                  <span className='inline-flex items-center gap-2 font-body text-2xs font-medium uppercase tracking-widest'>
                    <span
                      className={`h-1.5 w-1.5 ${
                        isCompleted ? "bg-primary/40" : "bg-accent"
                      }`}
                    />
                    <span
                      className={
                        isCompleted ? "text-primary/50" : "text-primary"
                      }
                    >
                      {isCompleted ? "Completed" : "In Progress"}
                    </span>
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Education;
